import {
  HttpContextToken,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';
import { UI } from 'src/app/core/helpers/ui';
import { environment } from 'src/environments/environment';

export const SHOW_LOADING = new HttpContextToken<boolean>(() => true); // default to show the loading for all requests
export const LOADING_MESSAGE = new HttpContextToken<string>(() => null);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private ui = inject(UI);
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {
    let shouldShowLoading = req.context.get(SHOW_LOADING);
    if (req.url.includes(environment.identityServer)) {
      // when refreshing the token /connect/token, /.well-known/openid-configuration/jwks, /connect/userinfo causes the loading to show
      // this looks weird when the user didn't make any action on the page
      shouldShowLoading = false;
    }
    if (shouldShowLoading) {
      const loadingMessage = req.context.get(LOADING_MESSAGE);
      const loading = this.ui.showLoading(loadingMessage);
      return from(loading).pipe(
        switchMap(() => {
          return next.handle(req).pipe(
            finalize(async () => {
              await this.ui.hideLoading();
            })
          );
        })
      );
    }
    return next.handle(req);
  }
}
